import { render, staticRenderFns } from "./Processlegislation.vue?vue&type=template&id=6d018e6e&scoped=true"
import script from "./Processlegislation.vue?vue&type=script&lang=js"
export * from "./Processlegislation.vue?vue&type=script&lang=js"
import style0 from "./Processlegislation.vue?vue&type=style&index=0&id=6d018e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d018e6e",
  null
  
)

export default component.exports